export function checkPermissions (value) {
  const permissions = JSON.parse(window.localStorage.getItem('permissions'))
  const found = permissions.find(element => element.name === value)
  if (found) {
    return true
  } else {
    return false
  }
}
